import { getMedia } from './getMedia';

export default function checkHasMedia(checkout, product) {
  const media = getMedia({ checkout, product });
  return media && media.length > 0;
}
